<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="trashgroupsfilter"
                  @select="handleSelectDistribuidor"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
                @select="handleSelectCliente"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="trash-groups-filter-name-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.name')}}</span>
              <el-form-item prop="name">
                <el-input
                  aria-labelledby="trash-groups-filter-name-label"
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                >
                  <template v-if="form.name.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo del nombre"
                      @clear="form.name.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div v-if="role === 'SuperAdministrador'">
              <AccessibleElSelect
                v-model="form.tipoGrupo.value"
                prop="tipoGrupo"
                :options="tiposGruposForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('configurations.type')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.verTodoGroups.value"
                prop="verTodoGroups"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_groups')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.verTodoStatuses.value"
                prop="verTodoStatuses"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_statuses')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.verTodoCompanies.value"
                prop="verTodoCompanies"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_companies')}}</template>
              </AccessibleElSelect>
            </div>

            <div v-if="hasModulePermisosGruposTraspasoNEOs">
              <AccessibleElSelect
                v-model="form.verTodoAsignarGrupos.value"
                prop="verTodoAsignarGrupos"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_groups_asign')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.send_alerts.value"
                prop="send_alerts"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('companies.send_alerts')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.enviarAvisosUsuarios.value"
                prop="enviarAvisosUsuarios"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="trashgroupsfilter"
              >
                <template slot="label">{{$t('configurations.send_alerts_users')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="trash-groups-filter-email-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email')}}</span>
              <el-form-item prop="email">
                <el-input
                  aria-labelledby="trash-groups-filter-email-label"
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="500"
                >
                  <template v-if="form.email.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de email"
                      @clear="form.email.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div v-if="hasPermModuleSMS">
              <span id="trash-groups-filter-phone-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.phone')}}</span>
              <el-form-item prop="phone">
                <el-input
                  aria-labelledby="trash-groups-filter-phone-label"
                  class="w-full"
                  v-model="form.phone.value"
                  maxlength="9"
                >
                  <template v-if="form.phone.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de telefono"
                      @clear="form.phone.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { ROLES } from '@/config/roles'
import { TIPOS_GRUPO } from '@/config/tipos-grupo'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'trashGroups',
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.username'), value: '' },
        tipoGrupo: { label: i18n.t('configurations.type'), value: '' },
        verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        verTodoAsignarGrupos: { label: i18n.t('configurations.ver_todo_groups_asign'), value: '' },
        send_alerts: { label: 'Enviar avisos', value: '' },
        enviarAvisosUsuarios: { label: i18n.t('configurations.send_alerts_users'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        phone: { label: i18n.t('configurations.phone'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' }
      },
      tiposGrupos: TIPOS_GRUPO,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }
  },
  computed: {
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    tiposGruposForAccessibleSelect: function () {
      return this.tiposGrupos.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS'] &&
        (this.role === 'Administrador' || this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') 
    },
    hasModulePermisosGruposTraspasoNEOs () {
      return this.$store.getters['auth/hasModulePermisosGruposTraspasoNEOs']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.tipoGrupo.value = _temp.tipoGrupo !== undefined && _temp.tipoGrupo.value !== '' ? _temp.tipoGrupo.value : ''
        this.form.verTodoGroups.value = _temp.verTodoGroups !== undefined && _temp.verTodoGroups.value !== '' ? _temp.verTodoGroups.value : ''
        this.form.verTodoStatuses.value = _temp.verTodoStatuses !== undefined && _temp.verTodoStatuses.value !== '' ? _temp.verTodoStatuses.value : ''
        this.form.verTodoCompanies.value = _temp.verTodoCompanies !== undefined && _temp.verTodoCompanies.value !== '' ? _temp.verTodoCompanies.value : ''
        this.form.verTodoAsignarGrupos.value = _temp.verTodoAsignarGrupos !== undefined && _temp.verTodoAsignarGrupos.value !== '' ? _temp.verTodoAsignarGrupos.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.send_alerts.value = _temp.send_alerts !== undefined && _temp.send_alerts ? _temp.send_alerts.value : ''
        this.form.enviarAvisosUsuarios.value = _temp.enviarAvisosUsuarios !== undefined && _temp.enviarAvisosUsuarios ? _temp.enviarAvisosUsuarios.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.phone.value = _temp.phone !== undefined && _temp.phone.value !== '' ? _temp.phone.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.username'), value: '' },
        tipoGrupo: { label: i18n.t('configurations.type'), value: '' },
        verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        verTodoAsignarGrupos: { label: i18n.t('configurations.ver_todo_groups_asign'), value: '' },
        send_alerts: { label: 'Enviar avisos', value: '' },
        enviarAvisosUsuarios: { label: i18n.t('configurations.send_alerts_users'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        phone: { label: i18n.t('configurations.phone'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' }
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      // console.log(item)
    },
    handleSelectTag: function (item) {
      // console.log('handleSelectTag', item)
      this.form.nombreTag.value = item.id
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    handleSelectRole: function (item) {
      this.form.role.value = item.id
    },
    handleSelectTipoAuth: function (item) {
      this.form.tipoAuth.value = item.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
